import React, { useMemo, useState } from 'react'
import { always } from 'ramda'

export type TravelChatBotDialogStatusContextType = {
  isChatBotDialogOpened: boolean
  setChatBotDialogOpeningState: React.Dispatch<React.SetStateAction<boolean>>
}

export const TravelChatBotDialogStatusContext =
  React.createContext<TravelChatBotDialogStatusContextType>({
    isChatBotDialogOpened: false,
    setChatBotDialogOpeningState: always(false)
  })

export function TravelChatBotContextProvider(props: {
  children: React.ReactNode
}) {
  const { children } = props
  const [isChatBotDialogOpened, setChatBotDialogOpeningState] = useState(false)

  const chatBotDialogStatusContextValue = useMemo(
    () => ({
      isChatBotDialogOpened,
      setChatBotDialogOpeningState
    }),
    [isChatBotDialogOpened]
  )
  return (
    <TravelChatBotDialogStatusContext.Provider
      value={chatBotDialogStatusContextValue}
    >
      {children}
    </TravelChatBotDialogStatusContext.Provider>
  )
}
